"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineHomepageSlide11 = exports.HomepageSlide11 = void 0;
const lib_es2015_1 = require("@hodol/web-component-helper/lib-es2015");
const lib_es2015_2 = require("@hodol/dom-helper/lib-es2015");
class HomepageSlide11 extends HTMLElement {
    constructor() {
        super();
        const shadow = this.attachShadow({ mode: 'open' });
        shadow.innerHTML = `
    <style>
      :host {
        display: block;
        background-color: #f3f2ec;
        box-sizing: border-box;
        width: 100%;
        max-width: var(--slide-max-width, 100%);
        margin: auto;
      }

      div.up-arrow-container {
        display: flex;
        justify-content: flex-end;
      }
      
      div.up-arrow-container button {
        background-color: #000000;
        color: #f3f2ec;
        font-size: 1.8rem;
        width: 2.8rem;
        aspect-ratio: 1 / 1;
      }
      
      div.content-container {
        box-sizing: border-box;
        padding: 0 2rem;
      }
      div.content-container div.title {
        font-size: 0.9rem;
        font-weight: bold;
      }
      
      div.content-container div.content {
        margin-bottom: 0.5rem;
      }
      
      div.content-container div.logo-and-sns {
        display: grid;
        grid-template-columns: 1fr 1fr;
      }
      
      div.content-container div.logo-and-sns div.logo {
        display: flex;
        font-size: 6rem;
        justify-content: space-evenly;
        align-items: center;
        height: 15rem;
        font-family: 'quaaykop-medium', sans-serif;
      }
      
      div.content-container div.logo-and-sns div.sns {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 1rem;
      }
      
      @media (max-width: 600px) {
        :host {
          box-sizing: border-box;
        }
        div.content-container div.logo-and-sns {
          display: flex;
          flex-direction: column;
        }
        
        div.content-container div.logo-and-sns div.logo {
          font-size: 4.8rem;
        }
        
        div.content-container div.logo-and-sns div.sns {
          margin-bottom: 2rem;
        }
      }
    </style>
    <div class="up-arrow-container">
      <button class="go-to-top">&#8593;</button>
    </div>
    <div class="content-container">
      <div class="title">OFFICE</div>
      <div class="content">501, Teheran-ro, Gangnam-gu, Seoul, Republic of Korea</div>
      <div class="title">CONTACT</div>
      <div class="content">kyungjun.ji@bio-lj.com & LEMAN</div>
      <div class="logo-and-sns">
        <div class="logo">AiLEENE</div>
        <div class="sns">
          <a>Instagram</a>
          <a>Twitter</a>
          <a>YouTube</a>
        </div>
      </div>
    </div>`;
        (0, lib_es2015_2.getQuerySelectOrThrowError)(shadow, 'button.go-to-top').addEventListener('click', () => {
            this.dispatchEvent(new CustomEvent('click-go-to-top-btn', {
                bubbles: true,
                cancelable: true,
            }));
        });
    }
}
exports.HomepageSlide11 = HomepageSlide11;
const defineHomepageSlide11 = (name) => {
    (0, lib_es2015_1.defineIfUndefined)(name, HomepageSlide11);
};
exports.defineHomepageSlide11 = defineHomepageSlide11;
